import React from 'react';
import {connect} from "react-redux";
import { fetchOffers } from "../../actions/OfferActions"
import {
	TextField,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	MenuItem} from '@material-ui/core';
  
let closeImg = {cursor:'pointer', position:'absolute', top:'10px',  right:'10px',width: '20px'};
const offers = [
	{code:"ADHÉSION" , description: "ADHÉSION"},
	{code:"PACK SÉRÉNITÉ" , description: "PACK SÉRÉNITÉ"}
]
@connect ((store) =>{
	return {
		messages: store.messages.messages,
		offers: store.offer.offerList
	}
})

export default class MyAssistance extends React.Component {
	constructor() {
		super();
		this.state = {
			value: "CHOISIR MON OFFRE",
			open:false,
			titleBox: "",
			bodyBox:""
		}

		this.renderDialog = () => {
			return (
				<div style={{ width: '50%', margin: '0 auto' }}>
					<Dialog
						open={this.state.open}
						scroll={'paper'}
						>
						<DialogTitle>
							<div style={{ 'fontWeight': "700" }}>
								{this.state.titleBox}
								<a onClick={this.handleClose}>	<img src='https://d30y9cdsu7xlg0.cloudfront.net/png/53504-200.png' style={closeImg} /></a>
							</div>
						</DialogTitle>
						<DialogContent>
							<DialogContentText>
								{this.state.bodyBox.split('\n').map(function (item, key) {
									return (
										<li style={{ "listStyleType": "none" }} key={key}>
											{item}
											<br />
										</li>
									)
								})}
							</DialogContentText>
						</DialogContent>


					</Dialog>
				</div>
			);
		}
																			
		this.renderMenuADhesion = (messages) => {
			return (
	
				<div id="myAssistance" className="amount text-left">
					<label>{messages["common.block.assistance.my.offer.fancPlus"]}</label>
					<a onClick={this.handleLink.bind(this, messages["common.block.assistance.membership"],assistanceBlock.block1)} ><li  style={{ "marginLeft": "10px", "listStyleType": "disc" }}>{messages["common.block.assistance.membership"]}</li></a>
					<a onClick={this.handleLink.bind(this, messages["common.block.assistance.free.trial.offer"],assistanceBlock.block2)}><li style={{ "marginLeft": "10px", "listStyleType": "disc" }}>{messages["common.block.assistance.free.trial.offer"]}</li></a>
					<a ><li style={{ "marginLeft": "10px", "listStyleType": "disc" }}>{messages["common.block.assistance.conditions"]}</li></a>
					<a onClick={this.handleLink.bind(this, messages["common.block.assistance.discount"],assistanceBlock.block3)}><li>{messages["common.block.assistance.discount"]}</li></a>
					<a onClick={this.handleLink.bind(this, messages["common.block.assistance.options.delivery"],assistanceBlock.block4)}><li>{messages["common.block.assistance.options.delivery"]}</li></a>
					<a onClick={this.handleLink.bind(this, messages["common.block.assistance.loyalty"],assistanceBlock.block5)}><li>{messages["common.block.assistance.loyalty"]}</li></a>
					<a onClick={this.handleLink.bind(this, messages["common.block.assistance.get.my.cardFnac"],assistanceBlock.block6)}><li style={{ "marginLeft": "10px", "listStyleType": "disc" }}>{messages["common.block.assistance.get.my.cardFnac"]}</li></a>
					<a onClick={this.handleLink.bind(this, messages["common.block.assistance.renewal"],assistanceBlock.block7)}><li style={{ "marginLeft": "10px", "listStyleType": "disc" }}>{messages["common.block.assistance.renewal"]}</li></a>
					<a onClick={this.handleLink.bind(this, messages["common.block.assistance.cancellation"],assistanceBlock.block8)}><li style={{ "marginLeft": "10px", "listStyleType": "disc" }}>{messages["common.block.assistance.cancellation"]}</li></a>
				</div>
			)
		}

		this.renderMenuPack = (messages) => {
			return (
				<div id="myAssistance" className="amount text-left" style={{"height":"180px"}}>
				</div>
			)
		}
	};

	handleClose = () => {
		this.setState({open: false});
	}

	componentDidMount() {
		this.props.dispatch(fetchOffers());
	}


	handleLink = (title, body) => {
		this.setState({ open: true, titleBox: title, bodyBox: body});
	};


	handleChange = (event) => {
		event && event.preventDefault();
		this.setState({value: event.target.value});
		};

	render() {
		const { messages } = this.props;
		return (
			<div className="col-md-12" >
				<div className="col-md-8">
					<div className="col-md-12">
						<p className="title stat-panel"> {messages["common.label.my.assistance"]}</p>
					</div>
				</div>

				<div className="col-md-6">
					<div className="col-md-12">
						<label className="sousTitle amount">{messages["common.label.help"]}</label>
						<div className="text-left">
							<TextField
								select
								className = "selectAssistance"
								InputLabelProps={{ shrink: true, }}
								onChange={this.handleChange}
								value={this.state.value}
								placeholder="Please select your title"
								margin="normal">
								<span className="grey-color" style={{ "paddingLeft": "15px", "color": "grey" }} value={this.state.value}> CHOISIR MON OFFRE </span>
								<span><i class="fa fa-angle-down" style={{ "fontSize": "20px", "paddingLeft": "190px" }}></i></span>
								{!!offers && offers.map(option => (
									<MenuItem key={option.code} value={option.code}>
										{option.description}
									</MenuItem>

								))}
							</TextField>
							{this.state.value === "ADHÉSION" &&
							<div className="text-left box-amount-small">
							
								<div className="text-left" >
									{this.renderMenuADhesion(messages)}
									{this.renderDialog()}
									<h4 className="amount"></h4>
								</div>

							
							</div>}
							{this.state.value === "PACK SÉRÉNITÉ" &&
							<div className="text-left box-amount-small">
						
								<div className="text-left" >
									{this.renderMenuPack(messages)}
									{this.renderDialog()}
									<h4 className="amount"></h4>
								</div>
						
							</div>}
						</div>
					</div>
				</div>

				<div className="col-md-6">
					<div className="col-md-12">
						<label className="sousTitle amount">{messages["common.label.contact.assistance"]}</label>
						<div className="text-center box-amount-small">
							<div className="text-left">
								<p><strong>{messages["common.label.customer.service"]}</strong></p>
								<p>{assitanceInfos.phone}</p>
								<p><strong>{assitanceInfos.info}</strong></p>
							</div>
						</div>
					</div>
				</div>
			</div>
	)
}
}



// WEBPACK FOOTER //
// ./src/opencell/pages/client/MyAssistance.jsx